// GA4 view_item_list
dataLayer.push({ecommerce: null});
dataLayer.push({
    event: "view_item_list",
    ecommerce: {
        currency: Shopify.currency.active,
        item_list_id: collection.id,
        item_list_name: collection.title,
        items: collection.products.map(function (item, index) {
            return {
                item_id: item.id,
                item_name: item.title,
                item_variant: item.variants[0].title,
                item_category: item.type,
                quantity: 1,
                index: index,
                item_list_id: collection.id,
                item_list_name: collection.title,
                price: item.price / 100
            }
        })
    }
});